export const ERROR_UPDATING_PREF_MISSING_INFORMATION =
  "Error updating payment pref instructions. Missing information. Please try again later";
export const ERROR_UPDATING_PREF_INVALID_TYPE =
  "Error updating payment pref instructions. Invalid type selected. Please try again later";

export class CustomConfirmationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CustomConfirmationError";
  }
}
